export const oneAppProfiles = [
  {
    name: 'Home',
    url: '/one-app/profiles/',
    icon: 'icon-home'
  }
];
